<ng-container *ngIf="sichtbar && schritt as s">

  <!-- Ohne Ziel: ganze Seite leicht abdunkeln -->
  <div class="wz-abdunkeln" *ngIf="!ziel"></div>

  <!-- Mit Ziel: Aussparung um das Element, der Rest wird abgedunkelt -->
  <div class="wz-spot" *ngIf="ziel as z" [style.top.px]="z.top" [style.left.px]="z.left"
    [style.width.px]="z.width" [style.height.px]="z.height">
  </div>


  <div #popup class="wz-popup" [ngClass]="'wz-' + platzierung" role="dialog" aria-labelledby="wz-titel"
    [style.top.px]="popupTop" [style.left.px]="popupLeft">

    <span class="wz-pfeil" *ngIf="zeigePfeil" [style.left.px]="pfeilHorizontal ? pfeil : null"
      [style.top.px]="pfeilHorizontal ? null : pfeil">
    </span>


    <div class="wz-kopf">

      <span class="wz-schritt">
        <mat-icon inline>assistant</mat-icon>
        Schritt {{ nummer }} von {{ anzahl }}
      </span>

      <button mat-icon-button type="button" class="wz-schliessen" aria-label="Assistent beenden"
        matTooltip="Assistent beenden" (click)="beenden()">
        <mat-icon>close</mat-icon>
      </button>

    </div>


    <div class="wz-fortschritt" aria-hidden="true">
      <span [style.width.%]="nummer / anzahl * 100"></span>
    </div>


    <h3 id="wz-titel" class="wz-titel">
      {{ s.titel }}
    </h3>

    <p class="wz-text">
      {{ s.text }}
    </p>

    <p class="wz-hinweis" *ngIf="hinweis">
      <mat-icon inline>hourglass_top</mat-icon>
      <span>{{ hinweis }}</span>
    </p>


    <div class="wz-aktionen">

      <button mat-button type="button" [disabled]="!kannZurueck" (click)="zurueck()">
        <mat-icon>arrow_back</mat-icon>
        Zurück
      </button>

      <button mat-button type="button" (click)="beenden()">
        Beenden
      </button>

      <span class="wz-spacer"></span>

      <!-- Auswahlschritte: der Weg entsteht durch den Klick auf der Seite -->
      <button mat-flat-button color="primary" type="button" *ngIf="!s.ohneWeiter" [disabled]="!bereit"
        (click)="weiter()">
        {{ istLetzter ? 'Fertig' : 'Weiter' }}
        <mat-icon iconPositionEnd *ngIf="!istLetzter">arrow_forward</mat-icon>
      </button>

    </div>

  </div>

</ng-container>
